export default __webpack_public_path__ + "static/media/aardbei_part.3f6921d3.png";